import type { IconButtonProps } from '@mui/material/IconButton';

import { user } from '@/store/reducerUser';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { usePopover } from 'minimal-shared/hooks';
import { useSelector } from 'react-redux';
import { CustomPopover } from 'src/components/custom-popover';

import { AccountButton } from './account-button';
import { SignOutButton } from './sign-out-button';

export function AccountPopover({ sx, ...other }: IconButtonProps) {
  const { open, anchorEl, onClose, onOpen } = usePopover();

  const userState = useSelector(user);

  const renderMenuActions = () => (
    <CustomPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      slotProps={{ paper: { sx: { p: 0, width: 200 } }, arrow: { offset: 20 } }}>
      <Box sx={{ p: 2, pb: 1.5 }}>
        <Typography variant="subtitle2" noWrap>
          {userState?.fullName}
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          {userState?.email}
        </Typography>
      </Box>

      <Divider sx={{ borderStyle: 'dashed' }} />

      <Box sx={{ p: 1 }}>
        <SignOutButton
          size="medium"
          variant="text"
          onClose={onClose}
          sx={{ display: 'block', textAlign: 'left' }}
        />
      </Box>
    </CustomPopover>
  );

  return (
    <>
      <AccountButton
        onClick={onOpen}
        photoURL={userState?.photoUrl || ''}
        displayName={userState?.fullName || ''}
        sx={sx}
        {...other}
      />

      {renderMenuActions()}
    </>
  );
}
